<div class="ui-radio-item" [class.disabled]="disabled">
  <div (click)="select()" class="ui-radio-item-btn" [class.active]="value === model" tabindex="0" (keydown.enter)="select()"></div>
  <p (click)="select()"><ng-content></ng-content></p>
</div>
<app-ui-tooltip *ngIf="tooltipText?.length" [content]="tooltipText" size="small"></app-ui-tooltip>
